import DashboardLayout from '../layouts/DashboardLayout'

export const tutorTestMenu = {
  path: '',
  component: DashboardLayout,
  name: 'Tutors',
  // redirect: '/tutor',
  children: [
    {
      path: 'tutor-test',
      name: 'Tutor Employee Report',
      component: () => import(/* webpackChunkName: "about" */'../pages/tutor/Tutor'),
      meta: {
        roles: ['tutor-test_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Dashboard Tutor',
        }]
      },
    },
    {
      path: 'tutor-test/:id',
      name: 'Tutor Employee Report',
      component: () => import(/* webpackChunkName: "about" */'../pages/tutor/Tutor'),
      meta: {
        roles: ['tutor-test_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Dashboard Tutor',
        }]
      },
    }
  ],
}